import img1 from '@/assets/images/decorations/2-2.png'
import img2 from '@/assets/images/decorations/3.png'
import img3 from '@/assets/images/decorations/5.png'
import img4 from '@/assets/images/decorations/6.png'

export default [
  {
    position: { x: -27, y: 25 },
    stackedPosition: { x: -1, y: 25 },
    size: { width: 60, height: 60 },
    cover: img1
  },
  {
    position: { x: 22, y: 16 },
    stackedPosition: { x: 28, y: -10 },
    size: { width: 60, height: 60 },
    cover: img2
  },
  {
    position: { x: 28, y: -25 },
    stackedPosition: { x: 10, y: -25 },
    size: { width: 60, height: 60 },
    cover: img3
  },
  {
    position: { x: -21, y: -27 },
    stackedPosition: { x: -29, y: -1 },
    size: { width: 60, height: 60 },
    cover: img4
  }
]
